import { Routes } from '@angular/router';

/**
 * Anciennes URL déplacées par la navigation à 5 entrées (maquette journal-audit, 2026-10-07).
 * Toutes les autres pages ont gardé leur URL : seules celles listées ici ont bougé. À placer
 * AVANT les routes de section dans `app.routes.ts` (`users/audit` serait sinon pris par `users`).
 * `redirectTo` garde les paramètres et le fragment (liens de notification filtrés).
 */
export const LEGACY_REDIRECTS: Routes = [
  // Users › Audit → Administration › Journal d'audit.
  { path: 'users/audit', pathMatch: 'full', redirectTo: 'admin/journal' },
  { path: 'admin', pathMatch: 'full', redirectTo: 'admin/journal' },
];
